export const MAX_TEXT_LENGTH: number = 200
export const MAX_URL_LENGTH: number = 50

export const PER_PAGE: number = 50
export const PAGE_SIZES: number[] = [10, 20, 30, 40, 50]

export const MAX_IMAGE_SIZE: number = 2 * 1024 * 1024
export const ACCEPTED_IMAGE_TYPES: string =
  '.jpg, .jpeg, .png, .gif, .svg, .avif, .tif, .tiff, .webp files are accepted.'
export const ACCEPTED_IMAGE_MIME_TYPES: string[] = [
  'image/jpeg',
  'image/png',
  'image/jpg',
  'image/gif',
  'image/svg+xml',
  'image/avif',
  'image/tiff',
  'image/webp',
]
export const ACCEPTED_XLS_TYPES: string = '.xls, .xlsx files are accepted.'
export const ACCEPTED_XLS_MIME_TYPES: string[] = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]
export const MAX_SMS_FILES: number = 10
export const MAX_SMS_FILE_SIZE: number = 5 * 1024 * 1024
export const MAX_FILE_SIZE: number = 100 * 1024 * 1024
export const ACCEPTED_FILE_TYPES: string =
  '.pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .jpeg, .png, .jpg, .gif, .svg, .avif, .tif, .tiff, .webp, .zip, .rar, .dcm, .hl7, .xml, .nii, .nii.gz, .edf, .cdf, .mhd, .raw, .pic, .hdr, .img are accepted.'
export const ACCEPTED_FILE_MIME_TYPES: string[] = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'image/jpeg',
  'image/png',
  'image/jpg',
  'image/gif',
  'image/svg+xml',
  'image/avif',
  'image/tiff',
  'image/webp',
  'application/zip',
  'application/x-rar-compressed',
  'application/dicom',
  'application/hl7',
  'application/xml',
  'application/nii',
  'application/x-nii.gz',
  'application/edf',
  'application/cdf',
  'application/mhd',
  'application/octet-stream',
]

export const ACCEPTED_MEDIA_MIME_TYPES: string[] = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'video/mp4',
  'video/quicktime',
  'audio/mpeg',
  'audio/ogg',
  'application/pdf',
]

export const PLACEHOLDER_SRC = `data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D`

export const COLORS_LIST: string[] = [
  '#000000',
  '#262626',
  '#595959',
  '#8C8C8C',
  '#BFBFBF',
  '#D9D9D9',
  '#E9E9E9',
  '#F5F5F5',
  '#FAFAFA',
  '#FFFFFF',
  '#F5222D',
  '#FA541C',
  '#FA8C16',
  '#FADB14',
  '#52C41A',
  '#13C2C2',
  '#1890FF',
  '#2F54EB',
  '#722ED1',
  '#EB2F96',
  '#FFE8E6',
  '#FFECE0',
  '#FFEFD1',
  '#FCFCCA',
  '#E4F7D2',
  '#D3F5F0',
  '#D4EEFC',
  '#DEE8FC',
  '#EFE1FA',
  '#FAE1EB',
  '#FFA39E',
  '#FFBB96',
  '#FFD591',
  '#FFFB8F',
  '#B7EB8F',
  '#87E8DE',
  '#91D5FF',
  '#ADC6FF',
  '#D3ADF7',
  '#FFADD2',
  '#FF4D4F',
  '#FF7A45',
  '#FFA940',
  '#FFEC3D',
  '#73D13D',
  '#36CFC9',
  '#40A9FF',
  '#597EF7',
  '#9254DE',
  '#F759AB',
  '#CF1322',
  '#D4380D',
  '#D46B08',
  '#D4B106',
  '#389E0D',
  '#08979C',
  '#096DD9',
  '#1D39C4',
  '#531DAB',
  '#C41D7F',
  '#820014',
  '#871400',
  '#873800',
  '#614700',
  '#135200',
  '#00474F',
  '#003A8C',
  '#061178',
  '#22075E',
  '#780650',
]

export const MIME_TYPE_BY_EXTENSION: Record<string, string> = {
  // images
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  svg: 'image/svg+xml',
  avif: 'image/avif',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  webp: 'image/webp',
  // documents
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  zip: 'application/zip',
  rar: 'application/x-rar-compressed',
  dcm: 'application/dicom',
  hl7: 'application/hl7',
  xml: 'application/xml',
  nii: 'application/nii',
  'nii.gz': 'application/x-nii.gz',
  edf: 'application/edf',
  cdf: 'application/cdf',
  mhd: 'application/mhd',
  raw: 'application/octet-stream',
  pic: 'application/octet-stream',
  hdr: 'application/octet-stream',
  img: 'application/octet-stream',
  // video
  mp4: 'video/mp4',
  avi: 'video/x-msvideo',
  mov: 'video/quicktime',
  wmv: 'video/x-ms-wmv',
  // audio
  mp3: 'audio/mpeg',
  ogg: 'audio/ogg',
  wav: 'audio/wav',
}
